export var CARE_CLIENT_VISITOR_STATE;
(function (CARE_CLIENT_VISITOR_STATE) {
    CARE_CLIENT_VISITOR_STATE[CARE_CLIENT_VISITOR_STATE["ACTIVE"] = 0] = "ACTIVE";
    CARE_CLIENT_VISITOR_STATE[CARE_CLIENT_VISITOR_STATE["END"] = 1] = "END";
    CARE_CLIENT_VISITOR_STATE[CARE_CLIENT_VISITOR_STATE["INVALID"] = 2] = "INVALID";
})(CARE_CLIENT_VISITOR_STATE || (CARE_CLIENT_VISITOR_STATE = {}));
